import { render, staticRenderFns } from "./CSidecover.vue?vue&type=template&id=6a9b0718&"
import script from "./CSidecover.vue?vue&type=script&lang=ts&"
export * from "./CSidecover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports